import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Slide,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import SchoolIcon from "@mui/icons-material/School";
import AssignmentIcon from "@mui/icons-material/Assignment";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import QuizIcon from "@mui/icons-material/Quiz";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import DashboardIcon from "@mui/icons-material/Dashboard";

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const modules = [
  {
    id: "admin",
    title: "Admin",
    icon: <AdminPanelSettingsIcon />,
  },
  {
    id: "hr",
    title: "HR",
    icon: <ContactMailIcon />,
  },
  {
    id: "sales",
    title: "Sales",
    icon: <BusinessCenterIcon />,
  },
  {
    id: "training",
    title: "Training",
    icon: <CoPresentIcon />,
  },
  {
    id: "client",
    title: "Client",
    icon: <AccountCircleIcon />,
  },
  {
    id: "employee",
    title: "HRMS",
    icon: <AssignmentIndIcon />,
  }
];

export default function ModuleSelectionPopup({ open, onClose, onSelect, roleTiles }) {
  const userInfo = useSelector((s) => s.loggedInUserInfo.userInfo);
  const [modulesWithPermission, setModulesWithPermission] = useState([]);
  const handleSelect = (module) => {
    onSelect(module);
  };

  useEffect(() => {
    if (roleTiles) {
      let moduleList = modules.filter(
        (o) => roleTiles.indexOf(o.id) > -1,
      );
      if(moduleList.length > 1){
        setModulesWithPermission(moduleList);
      }
      else{
        handleSelect(moduleList[0]);
      }
    }
  }, [roleTiles]);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar position="sticky" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flex: 1 }}>
            Select Module
          </Typography>

          {/* <IconButton edge="end" color="inherit" onClick={onClose}>
            <CloseIcon />
          </IconButton> */}
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          minHeight: "calc(100vh - 64px)",
          bgcolor: "#f5f7fb",
          p: { xs: 2, sm: 4 },
        }}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          sx={{ mb: 3, textAlign: "center" }}
        >
          Choose a Module
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {modulesWithPermission.map((module) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={module.id}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 4,
                  height: "100%",
                  transition: "0.25s",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: 8,
                  },
                }}
              >
                <CardActionArea
                  onClick={() => handleSelect(module)}
                  sx={{
                    height: "100%",
                    p: 3,
                    textAlign: "center",
                  }}
                >
                  <CardContent>
                    <Box
                      sx={{
                        width: 90,
                        height: 90,
                        mx: "auto",
                        mb: 2,
                        borderRadius: "50%",
                        bgcolor: "primary.light",
                        color: "primary.contrastText",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        "& svg": {
                          fontSize: 48,
                        },
                      }}
                    >
                      {module.icon}
                    </Box>

                    <Typography variant="h6" fontWeight={700}>
                      {module.title}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Dialog>
  );
}
